import { InjectionToken } from '@angular/core';

import { XpoAuthConfig } from './auth-config.model';

export const XPO_AUTH_CONFIG = new InjectionToken<XpoAuthConfig>('xpoAuthConfig');
